import { render } from "./Landing.vue?vue&type=template&id=f30fc068"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=f30fc068&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__